var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui segment" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.procedure.dataProduction != null
      ? _c("div", [
          _vm.procedure.dataProduction.method
            ? _c("div", [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm.getI18n(_vm.procedure.dataProduction.method, "en")
                    ) +
                    "\n\t\t"
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.procedure.lineageInformations != null
      ? _c(
          "div",
          { staticClass: "lineage-panel" },
          _vm._l(_vm.procedure.lineageInformations, function(
            lineageInformation,
            index
          ) {
            return _c("div", { key: index }, [
              _c("div", { staticClass: "ui segment" }, [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.getI18n(lineageInformation, "en")) +
                    "\n\t\t\t"
                )
              ])
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui top attached label" }, [
      _c("i", { staticClass: "cogs icon" }),
      _vm._v(" Data processing :\n\t")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }